<script lang="ts">
  export function tryNext() {
    return true;
  }
</script>


<div>
  <h3>Gewicht scores</h3>
  <ol>
    <li>Onvoldoende - presteert niet overeenkomstig de gestelde eisen</li>
    <li>Onder verwachting - presteert overeenkomstig de meeste, maar niet alle, gestelde eisen</li>
    <li>Volgens verwachting - presteert overeenkomstig de gestelde eisen</li>
    <li>Boven verwachting - presteert in veel gevallen boven de gestelde eisen </li>
    <li>Uitstekend - presteert in de meeste gevallen boven de gestelde eisen</li>
  </ol>
</div>